import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import {
  restartInteraction,
  setPage,
  WashingStore,
} from "../../../../stores/WashingStore/WashingStore";
import { TextContainer, Title } from "./SuccessPaymentStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
} from "../../TotemWashingStyles";
import { createTotemOrder } from "../../../../services/washingService";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";


const SuccessPayment: React.FC = () => {
  const {
    selectedWashing,
    selectedPayment,
    totemId,
    licencePlate,
    cieloTransactionId,
    taxId,
  } = useUnit(WashingStore);

  useEffect(() => {
    if (
      selectedWashing?.id &&
      selectedWashing?.price &&
      selectedPayment?.type &&
      totemId &&
      licencePlate
    ) {
      createTotemOrder({
        washingTypeId: selectedWashing.id,
        washingTypePrice: selectedWashing.price.toString(),
        licencePlate,
        paymentType: selectedPayment.type,
        taxId: taxId || "",
        totemId,
        cieloTransactionId: cieloTransactionId,
      }).catch((error) => {
        console.error("Error creating totem order:", error);
        handleFailedActivation();
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      restartInteraction();
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleFailedActivation = () => {
    setPage(PAGES.WASHING_PROCESS_ERROR);
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title style={{ marginBottom: "2rem" }}>Sucesso!</Title>
      </TextContainer>
    </GradientContainer>
  );
};

export default SuccessPayment;
